import * as React from 'react'
import cx from 'classnames'
import styles from './JobsListEmpty.sass'
import { EmptyState, EmptyStateIllustrationImage } from 'components/EmptyState'
import Button from 'components/Button'
import { useBrandingSettings } from 'hooks/branding'

interface JobsListEmptyProps {
  /**
   * Empty state title.
   */
  title?: string
  /**
   * Empty state subtitle.
   */
  subtitle?: React.ReactNode
  /**
   * Illustration image URL.
   */
  imageSrc?: string
  /**
   * Callback for clearing the search filter.
   */
  onClearSearchFilterClick?: () => unknown
  /**
   * Callback for setting the job scope.
   */
  onSetJobScope?: () => unknown
  /**
   * Children.
   */
  children?: React.ReactNode
}

export default function JobsListEmpty({
  subtitle,
  onClearSearchFilterClick,
  onSetJobScope,
  title = 'We looked everywhere...',
  imageSrc = require('assets/images/img_search-noresults.svg'),
  ...rest
}: JobsListEmptyProps) {
  const { corporateMode } = useBrandingSettings()

  subtitle = subtitle || (
    <>
      But we couldn't find what you were looking for.
      {onClearSearchFilterClick && (
        <>
          <br />
          Maybe try{' '}
          <Button
            size="baseline"
            onClick={onClearSearchFilterClick}
            type="text"
          >
            clearing your search filter
          </Button>{' '}
          {onSetJobScope && (
            <>
              or try{' '}
              <Button size="baseline" onClick={onSetJobScope} type="text">
                looking in all jobs
              </Button>
            </>
          )}
          ?
        </>
      )}
    </>
  )
  return (
    <div className={cx(styles.root)}>
      <EmptyState
        hideIllustration={corporateMode}
        animate
        small
        title={title}
        subtitle={subtitle}
        image={<EmptyStateIllustrationImage src={imageSrc} />}
        {...rest}
      />
    </div>
  )
}
